var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-dual-ring",style:({width: _vm.width + 'px', height: _vm.width + 'px'})},[_c('div',{staticClass:"lds-dual-ring-pseudo",style:({borderColor: _vm.color + ' transparent'})})])}
var staticRenderFns = []

export { render, staticRenderFns }